import { InsightPayloadUnion, InsightTag, InsightView } from '@ndvr/customer-api';

import { personRoute } from 'utils';

const SEPARATOR = ' — ';

export function getInsightSubtitle(insight: InsightView): { prefix: string; suffix: string; to: string } {
    const plainText = insight.subtitle?.plainText ?? '';
    // Split on the first separator only: the prefix is the linked subject (household/person name) and everything
    // after it — which may itself contain an em dash, e.g. inside an email subject — stays in a single suffix.
    const separatorIndex = plainText.indexOf(SEPARATOR);
    const prefix = (separatorIndex === -1 ? plainText : plainText.slice(0, separatorIndex)).trim();
    const suffix = separatorIndex === -1 ? '' : plainText.slice(separatorIndex + SEPARATOR.length).trim();
    return { prefix, suffix, to: getInsightLinkTarget(insight.payload) };
}

function getInsightLinkTarget(payload: InsightPayloadUnion): string {
    // An unanswered-email insight (client awaiting our reply, or us awaiting theirs) points straight at the specific
    // message, so the row resolves "which email?" in one click rather than dropping the advisor on the household profile.
    if (payload.type === InsightTag.R2 || payload.type === InsightTag.R3) {
        return `/household/${payload.householdGUID}/emails/${payload.emailGUID}`;
    }
    if ('subjectPersonOrgGUID' in payload) {
        return personRoute(payload.subjectPersonOrgGUID);
    }
    if ('householdGUID' in payload) {
        return `/household/${payload.householdGUID}`;
    }
    return '';
}
